<div class="row main-container h-100" [ngClass]="{ 'compact-mode': isCompactMode }">
  <div [ngClass]="{
      'col-12': isCompactMode || !bookAppointmentMode,
      'd-none d-sm-block col-sm-7 col-lg-9': !isCompactMode && bookAppointmentMode
    }" class="bg-white h-100">
    <div class="appointments-management-container w-100 h-100" [ngClass]="{ 'mb-sm-5': !bookAppointmentMode }">
      <div class="appointments-loader-overlay" *ngIf="isAppointmentsLoading">
        <mat-spinner diameter="36"></mat-spinner>
      </div>
      <div class="sticky-area w-100">
        @if (!isCompactMode) {
        <div class="appointments-mgmt-header d-md-flex px-4 pe-sm-2 pt-3 row align-items-center"
          [ngClass]="{'d-space-flex': bookAppointmentMode}">
          <div class="appointment-title-nav d-grid d-md-flex col-sm-4 col-lg-4  text-center text-sm-start">
            <h1 class="page-header-title ms-1">My Calendar <cva-manual-refresh [id]="practitionerId"
                [identifier]="manualRefreshIdentifier" [additionalData]="additionalParams"
                (dataFetched)="patchRefreshedData($event)"></cva-manual-refresh></h1>
            <div class="d-md-none user-profile d-flex align-items-center justify-content-center">
              <mat-icon [matMenuTriggerFor]="userMenu" class="pointer">person_outline</mat-icon>
              <mat-menu #userMenu="matMenu" xPosition="after" class="user-menu-collapse">
                <cva-side-nav-user-menu-items></cva-side-nav-user-menu-items>
              </mat-menu>
            </div>
          </div>
          <div class="col-12 my-3 my-sm-0 text-end d-sm-none sm-input">
            <div class="row align-items-center">
              <div class="col position-relative patient-filter-sm">
                <input type="text" class="form-control" placeholder="Filter appointments by patient name"
                  [(ngModel)]="appointmentFilterString" (input)="filterAppointments()">
                <i class="bi bi-search search-icon-sm ms-4"></i>
                @if (isVoiceInputActive) {
                <img [src]="cvaUI_url + '/assets/images/recording.gif'" alt="" class="recording-icon-sm me-4">
                } @else {
                <button type="button" class="mic-icon me-4 btn-invisible" (click)="onVoiceInput()">
                  <i class="bi bi-mic-fill"></i>
                </button>
                }
              </div>
            </div>
          </div>
          <div class="col-sm-8 col-md-8 col-lg-8 d-none d-sm-block" [ngClass]="{
            'col-width-8': bookAppointmentMode
          }">
            <button [hidden]="bookAppointmentMode" type="button"
              class="btn btn-outline-secondary add-aptmt-btn-lg float-end ms-3 new-aptmt-btn"
              (click)="openBookAppointment()" cvaAuthPermCheck [moduleName]='CVA_AUTH_MODULES.CVA_APPOINTMENT'
              [permissionType]='CVA_CONSTANTS.PERMISSION.WRITE' [actionType]='"disable"'>
              <i class="bi bi-plus-lg new-aptmt-icon"></i> New appointment
            </button>
            <div class="position-relative patient-filter-container-lg  col-md-6 col-lg-4">
              <input type="text" class="form-control patient-filter" placeholder="Filter appointments by patient name"
                [(ngModel)]="appointmentFilterString" (input)="filterAppointments()">
              <i class="bi bi-search search-icon ms-2"></i>
              @if (isVoiceInputActive) {
              <img [src]="cvaUI_url + '/assets/images/recording.gif'" alt="" class="recording-icon">
              } @else {
              <button type="button" class="mic-icon btn-invisible" (click)="onVoiceInput()">
                <i class="bi bi-mic-fill"></i>
              </button>
              }
            </div>
          </div>
        </div>
        }

        @if (isCompactMode) {
        <div class="compact-toolbar px-2 pt-2">
          <div class="position-relative compact-patient-filter-wrap">
            <input
              type="text"
              class="form-control compact-patient-filter"
              placeholder="Search patient in list"
              [(ngModel)]="appointmentFilterString"
              (input)="filterAppointments()">
            <i class="bi bi-search compact-search-icon"></i>
            @if (isVoiceInputActive) {
            <img [src]="cvaUI_url + '/assets/images/recording.gif'" alt="" class="compact-recording-icon">
            } @else {
            <button type="button" class="compact-mic-icon btn-invisible" (click)="onVoiceInput()" aria-label="Voice search">
              <i class="bi bi-mic-fill"></i>
            </button>
            }
          </div>

          <button
            [hidden]="externalBookingOpen"
            type="button"
            class="btn btn-outline-secondary compact-new-apt-btn"
            (click)="openBookAppointment()"
            cvaAuthPermCheck
            [moduleName]='CVA_AUTH_MODULES.CVA_APPOINTMENT'
            [permissionType]='CVA_CONSTANTS.PERMISSION.WRITE'
            [actionType]="'disable'">
            <i class="bi bi-plus-lg"></i>
            New appointment
          </button>
        </div>
        }

        <div class="flex-container col-12 date-filter-container" [ngClass]="{ 'compact-date-filter': isCompactMode }">
          @if (!isCompactMode) {
          <span class="date-text"><strong>{{selectedDate | date:"d MMM, y"}}</strong></span>
          <div class="date-input">
            <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate"
              (dateChange)="onDateSelect($event.value)">
            <mat-datepicker-toggle matIconSuffix [for]="picker">
            </mat-datepicker-toggle>
            <mat-datepicker #picker yPosition="below" xPosition="start"></mat-datepicker>
          </div>
          <button type="button" (click)="picker.open()" class="no-button">
            <mat-icon class="calendar-icon" fontIcon="calendar_month"></mat-icon>
          </button>
          }
          @if (isCompactMode) {
          <div class="compact-date-selector">
            <div class="compact-date-controls">
              <button type="button" class="compact-arrow-btn" (click)="goToPreviousDay()" aria-label="Previous day">
                <span class="compact-arrow-icon compact-arrow-left" aria-hidden="true"></span>
              </button>
              <button type="button" class="compact-today-btn" (click)="selectToday()">Today</button>
              <button type="button" class="compact-arrow-btn" (click)="goToNextDay()" aria-label="Next day">
                <span class="compact-arrow-icon compact-arrow-right" aria-hidden="true"></span>
              </button>
            </div>
            <button type="button" class="compact-date-display-btn" (click)="picker.open()" aria-label="Open date selector">
              <mat-icon class="date-text-icon" fontIcon="calendar_month"></mat-icon>
              <span class="date-text-compact">{{ selectedDate | date:"d MMM, y" }}</span>
            </button>
            <div class="date-input">
              <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" (dateChange)="onDateSelect($event.value)">
              <mat-datepicker #picker yPosition="below" xPosition="start"></mat-datepicker>
            </div>
          </div>
          }
          <button *ngIf="!isCompactMode" type="button" class="btn btn-outline-secondary btn-sm me-1 day-select-btn" id="select-today-btn"
            (click)="selectToday()" [class.btn-active]="dateMode === 'today'">Today</button>
          <button *ngIf="!isCompactMode" type="button" class="btn btn-outline-secondary btn-sm me-1 day-select-btn" id="select-tmrw-btn"
            (click)="selectTomorrow()" [class.btn-active]="dateMode === 'tomorrow'">Tomorrow</button>
          <button *ngIf="!isCompactMode" type="button" class="btn btn-outline-secondary btn-sm me-1 day-select-btn" id="select-day-aftr-btn"
            (click)="selectDayAfter()" [class.btn-active]="dateMode === 'dayAfter'">Day After</button>
          @if (!isCompactMode) {
          <button type="button" [hidden]="bookAppointmentMode" class="d-inline d-sm-none add-aptmt-btn-sm new-aptmt-btn"
            cvaAuthPermCheck [moduleName]='CVA_AUTH_MODULES.CVA_APPOINTMENT'
            [permissionType]='CVA_CONSTANTS.PERMISSION.WRITE' [actionType]='"disable"' (click)="openBookAppointment()">
            <i class="bi bi-plus"></i>
          </button>
          }
        </div>
      </div>
      <div class="px-4 bg-white pe-sm-2 pad-b-40">
        <mat-tab-group animationDuration="0ms" class="tab-view" mat-stretch-tabs="false"
        mat-align-tabs="start" disablePagination #tabGroup [(selectedIndex)]="selectedIndex" (selectedTabChange)="onTabChanged($event)">
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="tab-title" [class.active-tab]="tabGroup.selectedIndex === Tab.MY_APPOINTMENT">
                My Appointment
            </span>
        </ng-template>
        <div class="main-content">
          <div class="appointments-list-container flex-grow-1 overflow-y-auto px-4">

            <!-- Compact Dashboard Mode: Patient summary cards -->
            <div *ngIf="isCompactMode" class="compact-appointments-list">
              <ng-container *ngIf="filteredAppointments && filteredAppointments.length > 0; else compactNoRecord">
                <div class="compact-apt-card"
                     *ngFor="let appt of filteredAppointments"
                     [ngClass]="{'disabled-card': appt.isDeleted || !isCurrentDay}"
                   tabindex="0"
                     (click)="!appt.isDeleted && isCurrentDay && openAppointment({rowData: appt})">
                  <div class="compact-status-bar" [ngClass]="appt.status.toLowerCase()"></div>
                  <div class="compact-apt-body">
                    <div class="compact-apt-info">
                      <div class="compact-patient-name">{{ appt.patient.firstName }} {{ appt.patient.lastName }}</div>
                      <div class="compact-apt-meta">
                        <mat-icon class="compact-meta-icon">schedule</mat-icon>
                        <span class="compact-time">{{ appt.start | date:'h:mm a' }}</span>
                        <span class="compact-separator">·</span>
                        <span class="compact-type">{{ appt.appointmentType }}</span>
                      </div>
                    </div>
                    <div class="compact-apt-actions">
                      <ng-container *ngIf="appt.isDeleted; else actionButtons">
                        <span class="status-text">Cancelled</span>
                      </ng-container>
                      <ng-template #actionButtons>
                        <button 
                          type="button"
                          mat-icon-button
                          class="compact-action-btn transcript-btn"
                          [disabled]="!canViewTranscription(appt)"
                          [matTooltip]="getTranscriptionTooltip(appt)"
                          matTooltipClass="transcription-tooltip"
                          (click)="onActionClick({rowData: appt, action: 'transcription'}); $event.stopPropagation()"
                          aria-label="View transcription">
                          <img [src]="getTranscriptionIcon(appt)" alt="transcription" class="compact-icon">
                        </button>
                        <button 
                          type="button"
                          mat-icon-button
                          class="compact-action-btn delete-btn"
                          [disabled]="appt.pastAppointment || (isCurrentDay && appt.hasTranscription)"
                          [matTooltip]="appt.pastAppointment ? 'Cannot delete past appointment' : (isCurrentDay && appt.hasTranscription) ? 'Cannot delete - has transcription' : 'Delete appointment'"
                          (click)="onActionClick({rowData: appt, action: 'delete'}); $event.stopPropagation()"
                          aria-label="Delete appointment">
                          <i class="bi bi-trash3"></i>
                        </button>
                      </ng-template>
                    </div>
                    <mat-icon class="compact-chevron">chevron_right</mat-icon>
                  </div>
                </div>
              </ng-container>
              <ng-template #compactNoRecord>
                <div class="compact-empty-state">
                  <mat-icon>event_busy</mat-icon>
                  <p>No appointments</p>
                </div>
              </ng-template>
            </div>

            <!-- Normal Mode: Mobile screen -->
            <div *ngIf="!isCompactMode" class="d-block d-sm-none">
              <ng-container *ngIf="filteredAppointments && filteredAppointments.length > 0;else noRecordFound">
                <div class="my-2" *ngFor="let appointment of filteredAppointments;let last = last" aria-hidden="true"
                  [ngClass]="{'last-child': last}">
                  <cva-appointment-card [appointment]="appointment" (actionClick)="onActionClick($event)"
                    [isRowClickable]="isCurrentDay" (rowClick)="openAppointment($event)" cvaAuthPermCheck
                    [moduleName]='CVA_AUTH_MODULES.CVA_SOAP_NOTES' [permissionType]='CVA_CONSTANTS.PERMISSION.WRITE'
                    [actionType]='"disable"'></cva-appointment-card>
                </div>
              </ng-container>
              <ng-template #noRecordFound>
                <div class="row apt-container justify-content-center mb-4 p-4 text-grey">
                  <mat-card>
                    <mat-card-content class="text-center">
                      <strong>No Record Found.</strong>
                    </mat-card-content>
                  </mat-card>
                </div>
              </ng-template>
            </div>
            <!-- Normal Mode: Desktop Screen -->
            <div *ngIf="!isCompactMode" class="d-none d-sm-block">
              <div class="table-container text-capitalize">
                <cva-data-table [displayedColumns]="displayedColumns" [tableData]="filteredAppointments" [pageSize]="10"
                  [pageSizeOptions]="[5,10,15,20,25,30]" [tableClass]="'appointments-table'" [isEditable]="false"
                  [isDeletable]="true" [isRowClickable]="isCurrentDay"
                  [deleteConfirmationMessage]="deleteConfirmationMessage" [skipConfirmationPopup]="true"
                  (actionClick)="onActionClick($event)" (rowClick)="openAppointment($event)" cvaAuthPermCheck
                  [maxLength]="50" [moduleName]='CVA_AUTH_MODULES.CVA_SOAP_NOTES'
                  [permissionType]='CVA_CONSTANTS.PERMISSION.WRITE' [actionType]='"disable"'
                  [showPagination]="showPagination"></cva-data-table>
              </div>
            </div>

          </div>
        </div>

        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="tab-title" [class.active-tab]="tabGroup.selectedIndex === Tab.WALK_IN">
                Walkins
            </span>
        </ng-template>
        <div class="main-content">
          <div class="appointments-list-container flex-grow-1 overflow-y-auto px-4">

            <!-- Compact Dashboard Mode: Patient summary cards (Walk-in) -->
            <div *ngIf="isCompactMode" class="compact-appointments-list">
              <ng-container *ngIf="filteredWalkInAppointments && filteredWalkInAppointments.length > 0; else compactNoRecordWalkin">
                <div class="compact-apt-card"
                     *ngFor="let appt of filteredWalkInAppointments"
                     [ngClass]="{'disabled-card': appt.isDeleted || !isCurrentDay}"
                   tabindex="0"
                     (click)="!appt.isDeleted && isCurrentDay && openAppointment({rowData: appt})">
                  <div class="compact-status-bar" [ngClass]="appt.status.toLowerCase()"></div>
                  <div class="compact-apt-body">
                    <div class="compact-apt-info">
                      <div class="compact-patient-name">{{ appt.patient.firstName }} {{ appt.patient.lastName }}</div>
                      <div class="compact-apt-meta">
                        <mat-icon class="compact-meta-icon">schedule</mat-icon>
                        <span class="compact-time">{{ appt.start | date:'h:mm a' }}</span>
                        <span class="compact-separator">·</span>
                        <span class="compact-type">{{ appt.appointmentType }}</span>
                      </div>
                    </div>
                    <div class="compact-apt-actions">
                      <ng-container *ngIf="appt.isDeleted; else actionButtons">
                        <span class="status-text">Cancelled</span>
                      </ng-container>
                      <ng-template #actionButtons>
                        <button 
                          type="button"
                          mat-icon-button
                          class="compact-action-btn transcript-btn"
                          [disabled]="!canViewTranscription(appt)"
                          [matTooltip]="getTranscriptionTooltip(appt)"
                          matTooltipClass="transcription-tooltip"
                          (click)="onActionClick({rowData: appt, action: 'transcription'}); $event.stopPropagation()"
                          aria-label="View transcription">
                          <img [src]="getTranscriptionIcon(appt)" alt="transcription" class="compact-icon">
                        </button>
                        <button 
                          type="button"
                          mat-icon-button
                          class="compact-action-btn delete-btn"
                          [disabled]="appt.pastAppointment || (isCurrentDay && appt.hasTranscription)"
                          [matTooltip]="appt.pastAppointment ? 'Cannot delete past appointment' : (isCurrentDay && appt.hasTranscription) ? 'Cannot delete - has transcription' : 'Delete appointment'"
                          (click)="onActionClick({rowData: appt, action: 'delete'}); $event.stopPropagation()"
                          aria-label="Delete appointment">
                          <i class="bi bi-trash3"></i>
                        </button>
                      </ng-template>
                    </div>
                    <mat-icon class="compact-chevron">chevron_right</mat-icon>
                  </div>
                </div>
              </ng-container>
              <ng-template #compactNoRecordWalkin>
                <div class="compact-empty-state">
                  <mat-icon>directions_walk</mat-icon>
                  <p>No walk-in appointments</p>
                </div>
              </ng-template>
            </div>

            <!-- Normal Mode: Mobile screen -->
            <div *ngIf="!isCompactMode" class="d-block d-sm-none">
              <ng-container *ngIf="filteredWalkInAppointments && filteredWalkInAppointments.length > 0;else noWalkinRecordFound">
                <div class="my-2" *ngFor="let walkInAppointment of filteredWalkInAppointments;let last = last" aria-hidden="true"
                  [ngClass]="{'last-child': last}">
                  <cva-appointment-card [appointment]="walkInAppointment" (actionClick)="onActionClick($event)"
                    (rowClick)="openAppointment($event)" cvaAuthPermCheck
                    [moduleName]='CVA_AUTH_MODULES.CVA_SOAP_NOTES' [permissionType]='CVA_CONSTANTS.PERMISSION.WRITE'
                    [actionType]='"disable"'></cva-appointment-card>
                </div>
              </ng-container>
              <ng-template #noWalkinRecordFound>
                <div class="row apt-container justify-content-center mb-4 p-4 text-grey">
                  <mat-card>
                    <mat-card-content class="text-center">
                      <strong>No Record Found.</strong>
                    </mat-card-content>
                  </mat-card>
                </div>
              </ng-template>
            </div>
            <!-- Normal Mode: Desktop Screen -->
            <div *ngIf="!isCompactMode" class="d-none d-sm-block">
              <div class="table-container text-capitalize">
                <cva-data-table [displayedColumns]="displayedColumns" [tableData]="filteredWalkInAppointments" [pageSize]="10"
                  [pageSizeOptions]="[5,10,15,20,25,30]" [tableClass]="'appointments-table'" [isEditable]="false"
                  [isDeletable]="true" [isRowClickable]="isCurrentDay"
                  [deleteConfirmationMessage]="deleteConfirmationMessage" [skipConfirmationPopup]="true"
                  (actionClick)="onActionClick($event)" (rowClick)="openAppointment($event)" cvaAuthPermCheck
                  [maxLength]="50" [moduleName]='CVA_AUTH_MODULES.CVA_SOAP_NOTES'
                  [permissionType]='CVA_CONSTANTS.PERMISSION.WRITE' [actionType]='"disable"'
                  [showPagination]="showPagination"></cva-data-table>
              </div>
            </div>

          </div>
        </div>
  
        </mat-tab>
      </mat-tab-group>

      </div>

    </div>
  </div>
  <div *ngIf="bookAppointmentMode && !isCompactMode" class="col-12 col-sm-5 col-md-5 col-lg-3 appointment-booking-section">
    <cva-book-appointment (closeBookingSection)="onCloseBookingSection()"
      (appointmentBooked)="onAppointmentSchedule($event)"></cva-book-appointment>
  </div>
</div>
